import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useStyletron } from 'baseui'
import { Cell, Grid } from 'baseui/layout-grid'
import { FormControl } from 'baseui/form-control'
import { ModalHeader, ModalBody, ModalButton } from 'baseui/modal'
import { Textarea, SIZE } from 'baseui/textarea'

interface AbandonModalContentProps {
  onSubmit: (reason: string, callback: (success: boolean) => void) => void
  minLength?: number
}

const AbandonModalContent = ({ onSubmit, minLength = 0 }: AbandonModalContentProps) => {
  const { t } = useTranslation()
  const [css] = useStyletron()
  const [reason, setReason] = useState('')
  const [error, setError] = useState('')
  const [isLoading, setLoading] = useState(false)

  const handleResponse = (success: boolean) => {
    setLoading(false)
    if (!success) {
      setError(t('subscriptionTable:save_error'))
    }
  }

  const sendReason = () => {
    setLoading(true)
    setError('')
    if (reason.length === 0) {
      setError(t('subscriptionTable:mandatory_field'))
      setLoading(false)
      return
    }
    if (minLength > 0 && reason.trim().length < minLength) {
      setError(t('subscriptionTable:mandatory_field'))
      setLoading(false)
      return
    }
    onSubmit(reason, handleResponse)
  }

  return (
    <>
      <ModalHeader>{t('subscriptionTable:abandon_subscription')}</ModalHeader>
      <ModalBody>
        <Grid>
          <Cell span={12}>
            <FormControl label={t('subscriptionTable:abandon_why')} error={error}>
              <Textarea
                value={reason}
                onChange={e => setReason((e.target as HTMLTextAreaElement).value)}
                size={SIZE.mini}
                placeholder={t('subscriptionTable:write_comment')}
                clearable
              />
            </FormControl>
            <FormControl>
              <ModalButton
                className={css({ width: '100%' })}
                isLoading={isLoading}
                disabled={minLength > 0 && reason.trim().length < minLength}
                onClick={sendReason}
                size={SIZE.mini}
              >
                {t('subscriptionTable:abandon')}
              </ModalButton>
            </FormControl>
          </Cell>
        </Grid>
      </ModalBody>
    </>
  )
}

export default AbandonModalContent
